module.exports = require('./helpers/bundle-url').getBundleURL('jKRPl') + "elationemr-logo.0e2f19cd.png";